module.exports = __webpack_public_path__ + "prod/1.42.2/img/logo_three2x.49a6a9e5.png";